<template>
  <div id="artist-index-list">
    <button
      class="button-artist-list"
      :class="{ expanded: !isCollapsed }"
      @click="isCollapsed = !isCollapsed"
    >
      <component :is="buttonIcon" />
      <!-- <img :src="buttonIcon" /> -->
    </button>
    <div class="list-container" :class="isCollapsed ? 'collapsed' : ''">
      <div class="list-container__inner">
        <Loading v-if="allArtistsList.length == 0" color="black" />
        <template v-for="item in allArtistsList">
          <div :key="item.id" class="list-container__inner__heading">
            {{ item.heading }}
          </div>
          <ul :key="item.id">
            <li v-for="artist in item.artist" :key="artist.id">
              <router-link
                v-if="artistType"
                :to="{
                  name: artistType ? 'Artist' : 'Guest',
                  params: { id: artist.permlink }
                }"
              >
                {{ artist.name }}
              </router-link>
            </li>
          </ul>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import FilterAz from '@/components/svg/FilterAz.vue';
import FilterIconClose from '@/components/svg/FilterIconClose.vue';
import Loading from '@/components/ui/Loading.vue';
import axios from 'axios';
export default {
  name: 'ArtistIndexList',
  components: {
    Loading,
    FilterAz,
    FilterIconClose
  },
  props: {
    artistType: {
      type: String,
      required: false,
      default: ''
    }
  },

  data: () => ({
    isCollapsed: true,
    allArtistsList: []
  }),

  computed: {
    listDataLoaded() {
      return this.listData;
    },
    buttonIcon() {
      return this.isCollapsed ? FilterAz : FilterIconClose;
    }
  },

  watch: {
    isCollapsed(v) {
      if (!(v || this.allArtistsList.length)) {
        this.getArtistArchiveAll();
      }
    }
  },
  methods: {
    getArtistArchiveAll() {
      axios
        .get(`${this.$router.options.api}/artist/all-artists/${this.artistType}`)
        .then(response => {
          this.allArtistsList = this.artistsWithHeading(response.data);
        })
        .catch(error => {
          console.log(error);
        });
    },
    artistsWithHeading(allArtists) {
      let data = allArtists.reduce((r, e) => {
        // get first letter of artist name of current element
        let heading = e.name[0].toLowerCase();
        // if there is no property in accumulator with this letter create it
        if (!r[heading]) {
          r[heading] = {heading, artist: [e]};
        }
        // if there is push current element to children array for that letter
        else {
          r[heading].artist.push(e);
        }
        // return accumulator
        return r;
      }, {});
      return Object.values(data);
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/components/_artist-index-list.scss';
</style>
